if (!window.Eurus.loadedScript.has('cart-noti.js')) {
  window.Eurus.loadedScript.add('cart-noti.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xCartNoti', {
        enable: false,
        listItem: [],
        show: false,
        timer: null,
        paused: false,
        setItem(items) {
          this.listItem = [];
          if (items.items) {
            this.listItem = items.items
          } else {
            this.listItem.push(items);
          }
          this.open();
        },
        open() {
          clearTimeout(this.timer);
          this.paused = false;
          this.show = true;
          this.resume();
        },
        pause() {
          clearTimeout(this.timer);
          this.paused = true;
        },
        resume() {
          clearTimeout(this.timer);
          this.paused = false;
          // Keep the existing confirmation reachable on a phone until dismissed.
          if (!this.show || window.matchMedia('(max-width: 767px)').matches) return;
          this.timer = setTimeout(() => this.close(), 5000);
        },
        close() {
          clearTimeout(this.timer);
          this.show = false;
        }
      })
    });
  });
}